var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-switch',{attrs:{"checkedChildren":_vm.checkedChildren,"unCheckedChildren":_vm.unCheckedChildren,"disabled":_vm.disabled},on:{"change":_vm.onChange},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }